/**
 * This file exports unique symbols for various PubSub events 
 * @module events
 */

/**
 * mouse click
 */
export const MOUSE_CLICK      = Symbol('mouse.click');
/**
 * mouse move
 * @param {Object} position THREE.Vector2 Screen Location of the cursor
 */
export const MOUSE_MOVE       = Symbol('mouse.move');
/**
 * scrolling (mouse wheel change)
 */
export const MOUSE_WHEEL      = Symbol('mouse.wheel');


/**
 * mouse dragging (start)
 */
export const MOUSE_DRAG_START = Symbol('mouse.drag.start');
/**
 * mouse dragging (move)
 */
export const MOUSE_DRAG       = Symbol('mouse.drag.move');
/**
 * mouse dragging (end)
 */
export const MOUSE_DRAG_END   = Symbol('mouse.drag.end');


/**
 * keyboard key press
 */
export const KEY_DOWN         = Symbol('key.down');
/**
 * keyboard key release
 */
export const KEY_UP           = Symbol('key.up');
/**
 * movement through keyboard keys
 */
export const KEY_MOVE         = Symbol('key.move');
/**
 * movement stop through keyboard keys
 */
export const KEY_STOP         = Symbol('key.stop');


/**
 * loading start
 */
export const LOAD_START       = Symbol('load.start');
/**
 * loading end
 */
export const LOAD_END         = Symbol('load.end');